var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme4-sections"},[_c('theme4-section3'),_c('theme4-section4'),_c('theme4-section5'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }